// frontend/src/components/Common/LoadingSpinner.jsx
import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ fullScreen = false, size = 'medium', message = 'Loading...' }) => {
  const spinnerClass = `spinner spinner-${size} ${fullScreen ? 'full-screen' : ''}`;
  
  if (fullScreen) {
    return (
      <div className="loading-overlay">
        <div className="page-loader">
          <div className={`spinner spinner-${size}`}></div>
          {message && <p className="loading-message">{message}</p>}
        </div>
      </div>
    );
  }
  
  return (
    <div className="loading-container">
      <div className={`spinner spinner-${size}`}></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export const SkeletonLoader = ({ type = 'card', count = 1 }) => {
  const skeletons = Array(count).fill(0);
  
  return (
    <div className="skeleton-container">
      {skeletons.map((_, index) => (
        <div key={index} className={`skeleton skeleton-${type}`}>
          {type === 'card' && (
            <>
              <div className="skeleton-header"></div>
              <div className="skeleton-content">
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>
              </div>
            </>
          )}
          {type === 'list' && (
            <div className="skeleton-list">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
            </div>
          )}
          {type === 'text' && (
            <div className="skeleton-text"></div>
          )}
        </div>
      ))}
    </div>
  );
};

export const LoadingButton = ({ loading, children, ...props }) => {
  return (
    <button className="loading-button" disabled={loading} {...props}>
      {loading && <span className="button-spinner"></span>}
      {children}
    </button>
  );
};

export const DotsLoader = ({ size = 'medium', color = 'primary' }) => {
  const sizeClass = size === 'small' ? '0.375rem' : size === 'large' ? '0.625rem' : '0.5rem';
  
  return (
    <div className="dots-loader">
      <div className="dot" style={{ width: sizeClass, height: sizeClass }}></div>
      <div className="dot" style={{ width: sizeClass, height: sizeClass }}></div>
      <div className="dot" style={{ width: sizeClass, height: sizeClass }}></div>
    </div>
  );
};

export const ProgressBar = ({ progress = 0, indeterminate = false }) => {
  return (
    <div className="progress-bar">
      <div 
        className="progress-fill"
        style={!indeterminate ? { width: `${progress}%` } : {}}
      ></div>
    </div>
  );
};

export default LoadingSpinner;